import React, { Fragment } from 'react';
import { Segment, Form, Button, Table, Loader, Popup, Icon, Header } from 'semantic-ui-react';
import axios from 'axios';
import { ToastContainer, toast } from 'react-toastify';
import { fetchStudyType, fetchStudentStatuses, fetchCurrentAcademicYear } from '../Lookups/util';
import GetCertificate from './GetCertificate';


export default class StudentOverviewFilter extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            firstName: '',
            lastName: '',
            index: '',
            studentStudyProgramId: '',
            student: '',
            currentAcademicYear: '',

            studentStatuses: [],
            studyTypes: [],
            filterData: [],

            droppedOut: '',

            loading: false,
            getCertificate: false,
            locked: false

        };

        this.showStudent = this.showStudent.bind(this);
    }

    componentDidMount() {
        axios.all([fetchStudyType(), fetchStudentStatuses(), fetchCurrentAcademicYear()])
            .then(axios.spread((typesRes, statusesRes, currentYearRes) => {
                const studyTypes = typesRes.data.map(el => ({
                    ...el, key: el.id, value: el.id, text: el.displayName
                }));
                let studentStatuses = statusesRes.data.map(el => ({
                    ...el, key: el.id, value: el, text: el.name
                }));

                if (localStorage.getItem('activeRole').substr(0, 41) !== 'Studentska: Akademija scenskih umjetnosti') {
                    studentStatuses = studentStatuses.filter(el => el._key !== 'gap_year');
                }

                const currentAcademicYear = currentYearRes.data.id;
                this.setState({
                    studentStatuses, studyTypes, currentAcademicYear
                });
            }))
            .catch(err => {
                console.log('Failed to fetch study types or student statuses');
            });
    }

    showStudent() {
        const { firstName, lastName, index } = this.state;

        this.setState({ loading: true, show: true });

        if (!firstName && !lastName && !index) {
            toast('Morate unijeti bar jedan filter.');
            return;
        }

        let docFilter = {};

        if (firstName) docFilter = { ...docFilter, firstName };
        if (lastName) docFilter = { ...docFilter, lastName };
        if (index) docFilter = { ...docFilter, index };

        axios.post('students/filter-students-by-organizational-unit', { ...docFilter })
            .then(res => {
                const filterData = res.data.map(el => ({
                    ...el,
                    studyType: el.studyTypeId ? this.state.studyTypes.find(e => e.id === el.studyTypeId).name : null,
                    studentStatus: el.studentStatusId ? this.state.studentStatuses.find(e => e.id === el.studentStatusId).name : null
                }));
                this.setState({ filterData, loading: false });
            })
            .catch(err => {
                console.log('Failed to fetch filter results');
            });
    }


    render() {
        return (
            <div >
                <h1>Statusne potvrde i prepisi ocjena</h1>
                <Segment.Group raised>
                    {this.state.getCertificate && <Segment>
                        {/* <h3>{this.state.student}</h3> */}
                        <Header as="h3">
                            <Header.Content>
                                {this.state.student} - {this.state.index}
                                <Header.Subheader>Student/ica - index</Header.Subheader>
                            </Header.Content>
                        </Header>
                    </Segment>}
                    {!this.state.getCertificate ? <Fragment>
                        <Segment>
                            <h3>Studenti</h3>
                        </Segment>
                        <Segment clearing>
                            <Form>
                                <Form.Group widths="equal">
                                    <Form.Field>
                                        <label>Ime</label>
                                        <input
                                            value={this.state.firstName}
                                            onChange={(e) => this.setState({ firstName: e.target.value })}
                                            name="firstName"
                                            placeholder="Unesite ime"
                                        />
                                    </Form.Field>
                                    <Form.Field>
                                        <label>Prezime</label>
                                        <input
                                            value={this.state.lastName}
                                            onChange={(e) => this.setState({ lastName: e.target.value })}
                                            name="lastName"
                                            placeholder="Unesite prezime"
                                        />
                                    </Form.Field>
                                    <Form.Field>
                                        <label>Index</label>
                                        <input
                                            value={this.state.index}
                                            onChange={(e) => this.setState({ index: e.target.value })}
                                            name="index"
                                            placeholder="Unesite index"
                                        />
                                    </Form.Field>
                                </Form.Group>

                                <Button floated="right" color="blue" onClick={this.showStudent}>Prikaži studenta</Button>
                            </Form>
                        </Segment>
                        <ToastContainer hideProgressBar />
                    </Fragment>
                        : <Segment><GetCertificate
                            closeGetRequestMode={() => this.setState({
                                getCertificate: false, loading: false, firstName: '', lastName: '', index: '', show: false
                            })}
                            studentStudyProgramId={this.state.studentStudyProgramId}
                            student={this.state.student}
                            locked={this.state.locked}
                            studyProgramStudentSwitchedToId={this.state.studyProgramStudentSwitchedToId}
                            droppedOut={this.state.droppedOut !== null}
                            studentCertificate={false}
                        /></Segment>}

                    {this.state.show ?
                        this.state.loading ? <div style={{ paddingTop: '50px', paddingBottom: '50px' }}><Loader inline="centered" active /> </div> :
                            this.state.filterData.length ? <Segment><Table celled selectable compact >
                                <Table.Header>
                                    <Table.Row>
                                        <Table.HeaderCell>Prezime i ime studenta/ice</Table.HeaderCell>
                                        <Table.HeaderCell width="2">Broj indexa</Table.HeaderCell>
                                        <Table.HeaderCell>Odsjek</Table.HeaderCell>
                                        <Table.HeaderCell>Studijski program</Table.HeaderCell>
                                        <Table.HeaderCell verticalAlign="middle" width="2">
                                        </Table.HeaderCell>
                                    </Table.Row>
                                </Table.Header>
                                <Table.Body> {this.state.filterData.map((el, index) =>
                                    (<Table.Row key={index}>
                                        <Table.Cell verticalAlign="middle">
                                            {el.lastName} {el.firstName}
                                            {el.locked === 1 ? <span style={{ float: 'right' }}> <Icon name="lock" color="blue" /></span> : null}
                                            {el.studyProgramStudentSwitchedToId ? <span style={{ float: 'right' }}> <Icon name="check" color="blue" /></span> : null}
                                            {el.dateOfAbandonment !== null ? <span style={{ float: 'right' }}> <Icon name="sign-out" color="red" /></span> : null}
                                        </Table.Cell>
                                        <Table.Cell verticalAlign="middle" width="2">
                                            {el.index}
                                        </Table.Cell>
                                        <Table.Cell verticalAlign="middle">
                                            {el.departments.map(e => (<div>{e.name}<br /></div>))}
                                        </Table.Cell>
                                        <Table.Cell verticalAlign="middle">
                                            <strong>{el.studyProgramBasicName}</strong> | {el.studyProgramName}
                                        </Table.Cell>
                                        <Table.Cell textAlign="center" verticalAlign="middle" width="2">
                                            <Popup
                                                content="Izdavanje potvrde / prepisa ocjena"
                                                position="top center"
                                                trigger={
                                                    <Button
                                                        basic="true"
                                                        circular
                                                        icon="copy outline"
                                                        size="small"
                                                        color="blue"
                                                        onClick={() => {
                                                            window.scrollTo(0, 0);
                                                            this.setState({
                                                                getCertificate: true,
                                                                studentStudyProgramId: el.id,
                                                                student: el.firstName + ' ' + el.lastName,
                                                                locked: el.locked === 1,
                                                                index: el.index,
                                                                droppedOut: el.dateOfAbandonment,
                                                                studyProgramStudentSwitchedToId: el.studyProgramStudentSwitchedToId
                                                            });
                                                        }}
                                                    />}
                                            />
                                        </Table.Cell>
                                    </Table.Row>))}
                                </Table.Body>
                            </Table>
                            </Segment>
                                : <Segment> Nema studenata. </Segment>
                        : <Fragment />
                    }
                </Segment.Group>
            </div>
        );
    }
}




// WEBPACK FOOTER //
// ./src/views/CertificateRequest/SelectStudentsForCertificate.js